import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ImageSelectorItem } from './models/image-selector-item';

@Component({
    selector: 'sera-image-selector',
    templateUrl: './sera-image-selector.component.html',
    styleUrl: './sera-image-selector.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraImageSelectorComponent {
    @Input()
    images: ImageSelectorItem[] = [];

    @Input()
    numberOfColumns: number = 7;

    @Input()
    onImageSelectionChanged!: (selectedIds: number[]) => void;
}
